import React, { useEffect,useState } from 'react';
import ReactDOM from 'react-dom';
import './index.scss';

import { BrowserRouter, Switch, Route,Redirect } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import "@fortawesome/fontawesome-free/css/all.min.css";

// ** Import custom components for redux **
import { Provider } from 'react-redux';
import store from './store';
import App from "./components/app";
// Import custom Components 
import Dashboard from './components/dashboard/default';

// users
import UserEdit from './components/users/userEdit';

//resellers
import Resellers from './components/resellers/Summary';
import ResellerDetails from './components/resellers/Details';

import ResellerUsers from './components/reseller_users/Summary';
import ResellerUsersDetails from './components/reseller_users/Details';

//extensions
import Extensions from './components/app_management/extensions';
import ExtensionDetails from './components/app_management/ExtensionDetails';
import CheckEmail from './components/app_management/CheckEmail';


//users
import Users from './components/users/Summary'
import UserDetails from './components/users/Details'

//Client Profiles
import ClientProfiles from './components/clientProfiles/Summary'
import ClientProfileDetails from './components/clientProfiles/Details'

//Domains 
import Domains from './components/domains/Summary'
import DomainsDetails from './components/domains/Details'

// //Subscribers
// import Subscribers from './components/subscribers/Summary'
// import SubscriberDetails from './components/subscribers/Details'


//Licenses
import Licenses from './components/Licensing/licensing'
//Email templates
import EmailTemplates from './components/EmailTemplates/emailTemplates'

//logs
import Logs from './components/sysLogs/logs'

//docs
import DocsSummary from './components/docs/Summary'
import DocsDetails from './components/docs/Details'


// pages 
import Login from './pages/login';
import LoginWithBgImg from './pages/loginWithBgImg';
import LoginWithVideo from './pages/loginWithVideo';
import Signup from './pages/signup';
import SignupWithImg from './pages/signupWithImg';
import SignupWithVideo from './pages/signupWithVideo';
import UnlockUser from './pages/unlockUser';
import ForgetPwd from './pages/forgetPwd';
import ResetPwd from './pages/resetPwd';
import ComingSoon from './pages/comingsoon';
import ComingSoonImg from './pages/comingsoonImg';
import ComingSoonVideo from './pages/comingsoonVideo';
import Maintenance from './pages/maintenance';
import Error400 from './pages/errors/error400';
import Error401 from './pages/errors/error401';
import Error403 from './pages/errors/error403';
import Error404 from './pages/errors/error404';
import Error500 from './pages/errors/error500';
import Error503 from './pages/errors/error503';

import SettingsTab from './pages/settings';
import CDRS from './pages/cdr/CDRS';
import CDRSTABLE from './pages/cdrTable/CDRSTABLE';

import TestSDP from './pages/settings/testSDP';

import QRGenerator from './pages/settings/QrGenerator'; 

// Import Applications Components

import Signin from './auth/signin';
import AppSignin from './auth/appSignin';
import ResetPassword from './auth/resetPassword'
import ResetAppPassword from './auth/resetAppPassword'

//config data
import configDB from './data/customizer/config'
import resetAppPasswordReseller from './auth/resetAppPasswordReseller';


const Root = () => {

    const abortController = new AbortController();
    const [currentUser, setCurrentUser] = useState(false);
    const [authenticated,setAuthenticated] = useState(false)

    useEffect(() => {

        console.log(process.env.PUBLIC_URL);

        const color = localStorage.getItem('color')
        const layout = localStorage.getItem('layout_version') || configDB.data.color.layout_version
        setAuthenticated(JSON.parse(localStorage.getItem("authenticated")))
        document.body.classList.add(layout);
        console.ignoredYellowBox = ['Warning: Each', 'Warning: Failed'];
        console.disableYellowBox = true;
        document.getElementById("color").setAttribute("href", `${process.env.PUBLIC_URL}/assets/css/${color}.css`);

        return function cleanup() {
            abortController.abort();
        }
        
    // eslint-disable-next-line
    }, []);

    return (
        <div className="App">
            
            <Provider store={store}>
                <BrowserRouter basename={`/custom_tab`}>
                        <Switch>
                        </Switch>
                </BrowserRouter>
                <BrowserRouter basename={`/`}>
                        <Switch>
                            <Route path={`${process.env.PUBLIC_URL}/login`} component={Signin} />
                            <Route path={`${process.env.PUBLIC_URL}/appSignin`} component={AppSignin} />
                            <Route path={`${process.env.PUBLIC_URL}/resetPassword`} component={ResetPassword} />
                            <Route path={`${process.env.PUBLIC_URL}/resetAppPassword`} component={ResetAppPassword} />
                            <Route path={`${process.env.PUBLIC_URL}/resetResellerPassword`} component={resetAppPasswordReseller} />

                            <Route path={`${process.env.PUBLIC_URL}/pages/login`} component={Login} />
                            <Route path={`${process.env.PUBLIC_URL}/pages/loginWithBgImg`} component={LoginWithBgImg} />
                            <Route path={`${process.env.PUBLIC_URL}/pages/loginWithVideo`} component={LoginWithVideo} />
                            <Route path={`${process.env.PUBLIC_URL}/pages/signup`} component={Signup} />
                            <Route path={`${process.env.PUBLIC_URL}/pages/signupWithImg`} component={SignupWithImg} />
                            <Route path={`${process.env.PUBLIC_URL}/pages/signupWithVideo`} component={SignupWithVideo} />
                            <Route path={`${process.env.PUBLIC_URL}/pages/unlockUser`} component={UnlockUser} />
                            <Route path={`${process.env.PUBLIC_URL}/pages/forgetPwd`} component={ForgetPwd} />
                            <Route path={`${process.env.PUBLIC_URL}/pages/resetPwd`} component={ResetPwd} />
                            <Route path={`${process.env.PUBLIC_URL}/pages/comingsoon`} component={ComingSoon} />
                            <Route path={`${process.env.PUBLIC_URL}/pages/comingsoonImg`} component={ComingSoonImg} />
                            <Route path={`${process.env.PUBLIC_URL}/pages/comingsoonVideo`} component={ComingSoonVideo} />
                            <Route path={`${process.env.PUBLIC_URL}/pages/maintenance`} component={Maintenance} />
                            <Route path={`${process.env.PUBLIC_URL}/pages/errors/error400`} component={Error400} />
                            <Route path={`${process.env.PUBLIC_URL}/pages/errors/error401`} component={Error401} />
                            <Route path={`${process.env.PUBLIC_URL}/pages/errors/error403`} component={Error403} />
                            <Route path={`${process.env.PUBLIC_URL}/pages/errors/error404`} component={Error404} />
                            <Route path={`${process.env.PUBLIC_URL}/pages/errors/error500`} component={Error500} />
                            <Route path={`${process.env.PUBLIC_URL}/pages/errors/error503`} component={Error503} />
                            
                            {/* Custom Web Pages */}
                            <Route path={`${process.env.PUBLIC_URL}/settings_tab`} render={(props) => <SettingsTab {...props}/>}/>

                            <Route path={`${process.env.PUBLIC_URL}/cdrs`} render={(props) => <CDRS {...props}/>}/>
                            <Route path={`${process.env.PUBLIC_URL}/cdrs-table`} render={(props) => <CDRSTABLE {...props}/>}/>


                            <Route path={`${process.env.PUBLIC_URL}/getQR`} render={(props) => <QRGenerator {...props}/>}/>
                            
                            <Route path={`${process.env.PUBLIC_URL}/testSDP`} render={(props) => <TestSDP {...props}/>}/>

                            {localStorage.getItem('token') ?
                            
                                <App>
                                    {/* dashboard menu */}
                                    <Route exact path={`${process.env.PUBLIC_URL}/`} render={() => {
                                        return (<Redirect to={`${process.env.PUBLIC_URL}/dashboard`} />)
                                    }} />
                                    <Route path={`${process.env.PUBLIC_URL}/dashboard`} component={Dashboard} />

                                    {/* Users */}
                                    <Route path={`${process.env.PUBLIC_URL}/userEdit`} component={UserEdit} />

                                    <Route exact path={`${process.env.PUBLIC_URL}/resellers`} component={Resellers} />
                                    <Route exact path={`${process.env.PUBLIC_URL}/resellers/details`} component={ResellerDetails} />

                                    <Route exact path={`${process.env.PUBLIC_URL}/reseller_users`} component={ResellerUsers}/>
                                    <Route path={`${process.env.PUBLIC_URL}/reseller_users/details`} render={(props) => <ResellerUsersDetails {...props}/>}/>

                                    <Route exact path={`${process.env.PUBLIC_URL}/tenants`} component={Extensions} />
                                    <Route path={`${process.env.PUBLIC_URL}/tenants/details`} render={(props) => <ExtensionDetails {...props}/>}/>
                                    <Route path={`${process.env.PUBLIC_URL}/tenants/check_email`} render={(props) => <CheckEmail {...props}/>}/>
                                

                                    <Route exact path={`${process.env.PUBLIC_URL}/users`} component={Users}/>
                                    <Route path={`${process.env.PUBLIC_URL}/users/details`} render={(props) => <UserDetails {...props}/>}/>

                                    <Route exact path={`${process.env.PUBLIC_URL}/client_profiles`} component={ClientProfiles}/>
                                    <Route path={`${process.env.PUBLIC_URL}/client_profiles/details`} render={(props) => <ClientProfileDetails {...props}/>}/>

                                    <Route exact path={`${process.env.PUBLIC_URL}/domains`} component={Domains}/>
                                    <Route path={`${process.env.PUBLIC_URL}/domains/details`} render={(props) => <DomainsDetails {...props}/>}/>
                                    
                                    {/* <Route exact path={`${process.env.PUBLIC_URL}/subscribers`} component={Subscribers}/>
                                    <Route path={`${process.env.PUBLIC_URL}/subscribers/details`} render={(props) => <SubscriberDetails {...props}/>}/>*/}

                                    <Route path={`${process.env.PUBLIC_URL}/licenses`} component={Licenses} />
                                    <Route path={`${process.env.PUBLIC_URL}/email_templates`} component={EmailTemplates} />

                                    <Route path={`${process.env.PUBLIC_URL}/logs`} component={Logs} />

                                    <Route exact path={`${process.env.PUBLIC_URL}/docs`} component={DocsSummary} />
                                    <Route path={`${process.env.PUBLIC_URL}/docs/:docId`} component={DocsDetails} />

                                </App>
                            :
                            <App>
                                <Redirect to={`${process.env.PUBLIC_URL}/login`} />
                                <Route path={`${process.env.PUBLIC_URL}/resetPassword`} component={ResetPassword} />
                                
                            </App>
                            } 
                        </Switch>
                </BrowserRouter>
            </Provider>
            
        </div>
    );
}

ReactDOM.render(<Root />, document.getElementById('root'));

serviceWorker.unregister();